<div class="search-preview-container">
  <ngx-doc-viewer [url]="urlDoc"
                  [viewerUrl]="urlViewer"
                  viewer="url" style="width:100%;height:90vh;"></ngx-doc-viewer>
</div>
